module.exports = __webpack_public_path__ + "fonts/Gilroy-BlackItalic.25a0c193.ttf";